import { AxiosRequestConfig } from 'axios';
import { authService } from './auth';

/**
 * Request interceptor that adds authentication headers
 * This should be called manually when needed, not automatically on every request
 */
export const addAuthInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => {
  console.log('=== addAuthInterceptor START ===');
  const token = authService.getAuthToken();
  
  console.log('Token exists:', !!token);
  console.log('Original config headers:', config.headers);
  
  if (token) {
    console.log('Token found, adding Authorization header');
    const newConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    };
    
    console.log('New config headers:', newConfig.headers);
    console.log('=== addAuthInterceptor END (with token) ===');
    return newConfig;
  } else {
    console.log('No token found');
    console.log('=== addAuthInterceptor END (no token) ===');
  }
  return config;
};

/**
 * Create a request config with authentication headers
 */
export const createAuthConfig = (config?: AxiosRequestConfig): AxiosRequestConfig => {
  return addAuthInterceptor(config || {});
};

/**
 * Check if a request requires authentication based on URL pattern
 */
export const requiresAuth = (url: string): boolean => {
  // For now, let's add auth to all requests if token exists
  // The backend can handle unauthorized requests appropriately
  return true;
};

/**
 * Automatically add auth headers if the URL requires authentication
 */
export const autoAddAuthIfRequired = (url: string, config?: AxiosRequestConfig): AxiosRequestConfig => {
  console.log('=== autoAddAuthIfRequired START ===');
  console.log('autoAddAuthIfRequired called with:', { url, config });
  
  // Always try to add auth headers if token exists
  const result = addAuthInterceptor(config || {});
  console.log('autoAddAuthIfRequired result:', result);
  console.log('=== autoAddAuthIfRequired END ===');
  return result;
};
